<header class="header" [class.position-sticky]="!isMobile()">

  <h2 class="h2-semibold text-center">
    Your Preferences
  </h2>

  <p class="h6-regular text-center">
    At FarmBox, we tailor your shopping experience to <strong>YOU</strong>. When you tell us about your dislikes and
    likes we make sure
    to take that into consideration every week when we prepare your box. Please tell us a few of your personal
    preferences so that we can get to know you better.
  </p>

  <p class="h6-regular text-center">
    <b>💡 PRO TIP:</b>
    You can easily add more likes and dislikes later as you shop the store by clicking the heart or the thumbs down
    icons.
  </p>

  @if (!isMobile() && subscriptionCard().length) {
  <div class="d-grid gap-2 my-4 col-md-4 col-12 mx-auto">
    <button type="button" class="btn btn-secondary" (click)="continue()">
     Start Shopping
    </button>
  </div>
  }

</header>

<section class="preferences">

  <section class="row">

    @defer (when subscriptionCard().length) {
    @if (subscriptionCard()) {
    @for (product of subscriptionCard(); track product.id) {

    <div class="col-12 col-ms-6 col-md-6 col-lg-2 col-xxl-2 animated fadeIn">
      <div class="product-card-grid__item">
        <app-product-card-v2 [isPreference]="true" [isSignupFlow]="true"
          [cardResume]="{settings: {}, productDetails: product}"
          (outClickFavoriteOrDislike)="clickFavOrDisliked($event)"></app-product-card-v2>
      </div>
    </div>
    }
    }
    } @placeholder (minimum 1s) {
    <div class="loader-container">
      <div class="loader">
        @for (item of [0,0,0,0,0]; track $index) {
        <div class="bg-secondary"></div>
        }
      </div>
    </div>
    }

  </section>

</section>

@if (subscriptionCard().length && isMobile()) {
<div class="d-grid gap-2 mt-4 col-12 mx-auto sticky-button-container" [class.sticky-button-container]="isMobile()">
  <button type="button" class="btn btn-secondary" (click)="continue()">
    Start Shopping
  </button>
</div>
}
